import {Matrix4} from 'three'

const identity = new Matrix4();

export default {
    uniforms: {
        tDiffuse: { type: 't', value: null},
        alpha: {value: 1.0}
    },
  
    vertexShader: [
        'varying vec2 vUV;',
        'void main(void) {',
        '    gl_Position = projectionMatrix * viewMatrix * modelMatrix * vec4(position, 1.0);',
        '    vUV = uv;',
        '}'
    ].join('\n'),
  
    fragmentShader: [
        'precision highp float;',
        'precision highp sampler2D;',
        'uniform sampler2D tDiffuse;',
        'uniform float alpha;',
        'varying vec2 vUV;',
        
        'void main(void) {',
        '    vec3 col = texture2D(tDiffuse, vUV).rgb;',
            
        '    gl_FragColor = vec4(col*alpha, 1.0);',
        '}'
    ].join('\n')
  }